import { Ticket } from "./Entity";
import { StructuredOperationTypeFileModel } from "./StructuredOperationTypeFileModel";

export class StructuredOperationModel extends Ticket {
  // Dados Carteira
  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioName: string = null;
  isInternalFund = false;
  portfolioCode: string = null;
  portfolioCetipAccount: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;
  operationTypeFile: StructuredOperationTypeFileModel = null;
  tempTicketId: string = null;
  operationAbstract: string = null;
  annotations: string = null;
  originatorName: string = null;
  originatorDocument: string = null;
  activeName: string = null;
  activeDocument: string = null;
  activeProcess: string = null;
  activeRegistration: string = null;
  activeCity: string = null;
  activeUF: string = null;
}
